// extracted by mini-css-extract-plugin
export default {"root":"FavouriteButton-root","asLink":"FavouriteButton-asLink","favouriteCount":"FavouriteButton-favouriteCount"};